import { HttpTypes } from '@/types';
import { AdminReviewCreateResponse } from '@/types/http';
import { IReview } from '@/types/review';
import { AxiosInstance } from 'axios';

class Review {
  private client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async list(queryParams: unknown): Promise<HttpTypes.IResponse<IReview[]>> {
    const result = await this.client.get('/product/review', {
      params: queryParams,
    });

    return result.data;
  }

  async create(
    data: HttpTypes.AdminReviewCreatePayload
  ): Promise<HttpTypes.IResponse<AdminReviewCreateResponse>> {
    const result = await this.client.post('/product/review', data);
    return result.data;
  }

  async validate(
    data: HttpTypes.AdminValidateReviewPayload
  ): Promise<HttpTypes.IResponse<AdminReviewCreateResponse>> {
    const result = await this.client.put(`/product/review/${data.id}/validate`, data);
    return result.data;
  }

  async update(
    data: HttpTypes.AdminReviewCreatePayload
  ): Promise<HttpTypes.IResponse<AdminReviewCreateResponse>> {
    const result = await this.client.put(`/product/review/${data.id}`, data);
    return result.data;
  }

  async detail(id: string): Promise<HttpTypes.IResponse<IReview>> {
    const result = await this.client.get(`/product/review/${id}`);
    return result.data;
  }

  async delete(id: string): Promise<HttpTypes.IResponse<void>> {
    const result = await this.client.delete(`/product/review/${id}`);
    return result.data;
  }
}

export default Review;
